import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import SectionLoader from '@/src/components/common/Elements/Spinner/SectionLoader/SectionLoader';
import { RootState } from '@/src/reducers/types';

import Body from './Body/Body';
import Container from './Container/Container';
import Header from './Header/Header';
import SelectAllCheckbox from './Header/SelectAll/SelectAllCheckbox';

import { useGetRootFiles } from '../../api/getRootFiles';
import { FileListProvider } from '../../store/file-list.store';
import { useLibrarySearchParamsContext } from '../../store/filters.store';

type ListProps = {
  projectId: string;
  draggingData: any;
};

export const RootFilesList = ({ projectId, draggingData }: ListProps) => {
  const files = useSelector((state: RootState) => state.files);
  const folderId = files.activeFolder?.id;
  const selectedItems = files.selectedItems;
  const { filter } = useLibrarySearchParamsContext();
  const rootFilesQuery = useGetRootFiles({ projectId: +projectId, filter });
  const rootFiles = rootFilesQuery.data?.pages.flatMap((page) => page.data) || [];

  const isLoading = rootFilesQuery.isLoading;
  const showFolders = !folderId && rootFiles.length > 0;
  const showNoRecords = !isLoading && !folderId && !rootFiles.length;
  const filesWithSelection =
    rootFiles?.map((item) => ({
      ...item,
      isSelected: selectedItems.map((f) => f.id)?.includes(item.id),
    })) ?? [];

  // if (isLoading) {
  //   return (
  //     <Container>
  //       <Header />
  //       <SectionLoader />
  //     </Container>
  //   );
  // }

  return (
    <FileListProvider filesQuery={rootFilesQuery}>
      <Container>
        <Header SelectAllComponent={<SelectAllCheckbox flatFiles={rootFiles} />} />

        {showFolders && <Body list={filesWithSelection} draggingData={draggingData} />}

        {showNoRecords && <p className="noRecordsFound">No records found.</p>}

        {rootFilesQuery.hasNextPage && (
          <div className="loadMoreFiles">
            <a onClick={() => rootFilesQuery.fetchNextPage()}>Load More</a>
          </div>
        )}
      </Container>
    </FileListProvider>
  );
};
